import { useEffect, useRef } from "react";
import { apiCancellationManager } from "../utils/apiCancellationManager";

/**
 * Custom hook to manage cancellable API requests per module.
 */
const useApiCancellation = () => {
  const activeModuleNamesRef = useRef(new Set());

  // Create an AbortController for a specific module name
  const createAbortController = (moduleName) => {
    const controller = new AbortController();
    apiCancellationManager.addController(moduleName, controller);
    activeModuleNamesRef.current.add(moduleName);
    return controller;
  };

  // Cancel a specific module's request
  const cancelRequestsByModule = (moduleName) => {
    apiCancellationManager.cancelModuleRequests(moduleName);
    activeModuleNamesRef.current.delete(moduleName);
  };

  // Cancel all requests managed via this hook instance
  const cancelAllRequests = () => {
    activeModuleNamesRef.current.forEach((moduleName) => {
      apiCancellationManager.cancelModuleRequests(moduleName);
    });
    activeModuleNamesRef.current.clear();
  };

  // Automatically cancel all on unmount
  useEffect(() => {
    return () => {
      cancelAllRequests();
    };
  }, []);

  return {
    createAbortController,
    cancelRequestsByModule,
    cancelAllRequests,
  };
};

export default useApiCancellation;
